'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactDeviceDetect = require('react-device-detect');

var _wrapper = require('./wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _dialog = require('./dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _closeButton = require('./close-button');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _okButton = require('./ok-button');

var _okButton2 = _interopRequireDefault(_okButton);

var _content = require('./content');

var _content2 = _interopRequireDefault(_content);

var _anonymousConversion = require('../showbag/anonymous-conversion');

var _anonymousConversion2 = _interopRequireDefault(_anonymousConversion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconRowStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start'
};

var IconStyle = {
  border: '1px solid lightgray',
  padding: '0.5rem',
  borderRadius: '5px',
  marginRight: '1rem'
};

var ShowbagHelper = function (_Component) {
  _inherits(ShowbagHelper, _Component);

  /** @constructor
    * Creates a new instance of the showbag helper.
    */
  function ShowbagHelper(props) {
    _classCallCheck(this, ShowbagHelper);

    var _this = _possibleConstructorReturn(this, (ShowbagHelper.__proto__ || Object.getPrototypeOf(ShowbagHelper)).call(this, props));

    _this.state = { visible: false };
    return _this;
  }
  /** @method componentDidMount
    * Checks to see if the user has previously seen this hint,
    * and if not, displays it.
    */


  _createClass(ShowbagHelper, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Otherwise, check for a session record
      if (!window.vexpo) window.vexpo = {};
      if (!window.vexpo.hints) window.vexpo.hints = {};
      if (!window.vexpo.hints.showbag) {
        this.setState({ visible: true });
        window.vexpo.hints.showbag = true;
      }
    }
    /** @method render
      * Renders the overlay.
      */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var visibleClass = this.state.visible ? 'active' : '';
      var user = window.vexpo.firebase.auth().currentUser;
      var content = !user || user.isAnonymous ? _react2.default.createElement(_anonymousConversion2.default, { contents: [] }) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          'Add Content to your Favorites'
        ),
        _react2.default.createElement(
          'div',
          { style: IconRowStyle },
          _react2.default.createElement(
            'div',
            { style: IconStyle },
            _react2.default.createElement(_reactFontawesome2.default, { name: 'star-o', style: { color: "orange" }, size: '2x' })
          ),
          _react2.default.createElement(
            'div',
            null,
            _reactDeviceDetect.isMobile ? 'Tapping' : 'Clicking',
            ' the star outline on an item in a booth adds it to your Favorites list.'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: IconRowStyle },
          _react2.default.createElement(
            'div',
            { style: IconStyle },
            _react2.default.createElement(_reactFontawesome2.default, { name: 'star', style: { color: "orange" }, size: '2x' })
          ),
          _react2.default.createElement(
            'div',
            null,
            _reactDeviceDetect.isMobile ? 'Tapping' : 'Clicking',
            '  the filled star on an item removes it from your Favorites list.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Check your Favorites list by',
          _reactDeviceDetect.isMobile ? ' tapping ' : ' clicking ',
          'the "',
          _react2.default.createElement(_reactFontawesome2.default, { name: 'star' }),
          ' My Favorites" banner on the left side of the screen.'
        ),
        _react2.default.createElement(
          _okButton2.default,
          { onClick: function onClick() {
              return _this2.setState({ visible: false });
            } },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }),
          'Got it!'
        )
      );
      return _react2.default.createElement(
        _wrapper2.default,
        { className: visibleClass },
        _react2.default.createElement(
          _dialog2.default,
          null,
          _react2.default.createElement(
            _closeButton2.default,
            { onClick: function onClick() {
                return _this2.setState({ visible: false });
              } },
            'CLOSE',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times-circle' })
          ),
          _react2.default.createElement(
            _content2.default,
            null,
            content
          )
        )
      );
    }
  }]);

  return ShowbagHelper;
}(_react.Component);

exports.default = ShowbagHelper;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/helpers/showbag-helper.js
// module id = 1347
// module chunks = 0